<template lang="pug">
  table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle.d-none(:id="tblId")
    thead.thead-light
      tr
        th.text-center(width="3%")
          span #
        th(width="12%")
          span(:title="$t('ui.date_time')") {{ $t('ui.date_time') }}
        th(width="10%")
          span {{ $t('ui.result_id') }}
        th(width="10%")
          span {{ $t('ui.ip') }}
        th(width="10%")
          span(:title="$t('ui.account_id')") {{ $t('ui.account_id') }}
        th(width="10%")
          span(:title="$t('ui.sports_game')") {{ $t('ui.sports_game') }}
        th(width="15%")
          span(:title="$t('ui.event')") {{ $t('ui.event') }}
        th(width="10%")
          span(:title="$t('ui.detail')") {{ $t('ui.detail') }}
        th.text-right(width="10%")
          span(:title="$t('ui.turnover')") {{ $t('ui.turnover') }}
        th.text-right(width="10%")
          span(:title="$t('ui.valid_turnover')") {{ $t('ui.valid_turnover') }}
        th.text-right(width="10%")
          span(:title="$t('ui.payout')") {{ $t('ui.payout') }}
        th.text-right(width="10%")
          span(:title="$t('ui.winlose')") {{ $t('ui.winlose') }}
    tbody.clusterize-content
      tr(v-if="tbl.length == 0")
        td(colspan="10").text-center
          span {{ $t('message.no_data_available') }}
      tr(v-for="(item, index) in tbl")
        td.text-center
          span(:title="index + 1") {{ index + 1 }}
        td
          span(:title="$moment(item.bet_time).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.bet_time).format('YYYY-MM-DD, HH:mm:ss') }}
        td
          span.font-weight-bold(:title="item.result_id") {{ item.result_id }}
        td
          span(:title="item.ip") {{ item.ip }}
        td
          span(:title="item.member_id") {{ item.member_id }}&nbsp;
        td
          //- span(:title="item.sports_type") {{ item.sports_type }}
          //- br
          span(:title="item.sports_category") {{ item.sports_category }}&nbsp;
          br
          span(:title="item.game_type_name") {{ item.game_type_name }}&nbsp;
        td
          template(v-if="!['IB','CM','S3'].includes(item.provider_code)")
            small {{  item.provider_code }}
            template(v-if="item.bet_type != 'PARLAY'")
              template(v-if="item.result_id.startsWith('9W_')")
                span.font-weight-bold(:title="item.league_name") {{ item.league_name }}&nbsp;
                br
                template(v-if="item.game_type_name")
                  span.text-success(:title="item.game_type_name") {{ item.game_type_name.split(" v ")[0] }}&nbsp;
                  span vs&nbsp;
                  span.text-danger(:title="item.game_type_name") {{ item.game_type_name.split(" v ")[1] }}&nbsp;
              template(v-else)
                span.font-weight-bold(:title="item.league_name") {{ item.league_name }}&nbsp;
                template(v-if="item.home_team_name != null && item.away_team_name != null")
                  br
                  span.text-success(:title="item.home_team_name") {{ item.home_team_name  }}&nbsp;
                  span vs&nbsp;
                  span.text-danger(:title="item.away_team_name") {{ item.away_team_name }}&nbsp;
                br
                span.text-info(:title="$moment(item.match_time).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.match_time).format('YYYY-MM-DD, HH:mm:ss') }}
                span.text-primary(v-if="item.home_score != null && item.away_score != null" :title="'(' + item.home_score + ' - ' + item.away_score + ')'") {{ '(' + item.home_score + ' - ' + item.away_score + ')' }}
            template(v-else)
              span.font-weight-bold(:title="$t('ui.mix_parlay')") {{ $t("ui.mix_parlay") }}
              br
              span(:title="item.odds_display_bet") {{ item.odds_display_bet }}&nbsp;                      
        td
          template(v-if="!['IB','CM','S3'].includes(item.provider_code)")
            span(:title="item.bet_type") {{ item.bet_type }}&nbsp;
            br
            span(:title="item.bet_hand") {{ item.bet_hand }}&nbsp;
            br
            span(v-if="item.odds_display != null" :title="item.odds_display + ' ' + getOddsType(item.odds_type)") {{ item.odds_display + ' ' + getOddsType(item.odds_type) }}&nbsp;
          //- template(v-else)
          //-   i.fas.fa-comment-dots.text-primary(
          //-     role="button"
          //-     :title="$t('ui.remark')"
          //-     style="cursor: pointer;"
          //-     @click="openRemarkModal(item.remark, item.provider_code)"
          //-   )
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(item.turnover)" :title="$n(item.turnover, 'currency')") {{ $n(item.turnover, 'currency') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(item.valid_turnover)" :title="$n(item.valid_turnover, 'currency')") {{ $n(item.valid_turnover, 'currency') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(item.payout)" :title="$n(item.payout, 'currency')") {{ $n(item.payout, 'currency') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(item.winlose)" :title="$n(item.winlose, 'currency')") {{ $n(item.winlose, 'currency') }}
      tr.footer
        td.text-right(colspan="8")
          span {{ $t("ui.sub_total") }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(subTotalTurnover)" :title="$n(subTotalTurnover, 'currency')") {{ $n(subTotalTurnover, 'currency') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(subTotalValidTurnover)" :title="$n(subTotalValidTurnover, 'currency')") {{ $n(subTotalValidTurnover, 'currency') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(subTotalPayout)" :title="$n(subTotalPayout, 'currency')") {{ $n(subTotalPayout, 'currency') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(subTotalWinLose)" :title="$n(subTotalWinLose, 'currency')") {{ $n(subTotalWinLose, 'currency') }}

      tr.footer
        td.text-right(colspan="8")
          span {{ $t("ui.grand_total") }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalTurnover)" :title="$n(grandTotalTurnover, 'currency')") {{ $n(grandTotalTurnover, 'currency') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalValidTurnover)" :title="$n(grandTotalValidTurnover, 'currency')") {{ $n(grandTotalValidTurnover, 'currency') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalPayout)" :title="$n(grandTotalPayout, 'currency')") {{ $n(grandTotalPayout, 'currency') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalWinLose)" :title="$n(grandTotalWinLose, 'currency')") {{ $n(grandTotalWinLose, 'currency') }}
</template>
<script>
export default {
  props: {
    tbl: {
      type: Array,
      default() {
        return []
      }
    },
    totalTbl: {
      type: Array,
      default() {
        return []
      }
    },
    tblId: {
      type: String,
      default: ""
    },
  },
  data: () => ({
    loading: false,
    subTotalTurnover: 0,
    grandTotalTurnover: 0,
    subTotalValidTurnover: 0,
    grandTotalValidTurnover: 0,
    subTotalWinLose: 0,
    grandTotalWinLose: 0,
    subTotalPayout: 0,
    grandTotalPayout: 0
  }),
  watch: {
    tbl(newValue, oldValue) {
      this.getTotal();
    },
  },
  mounted: function() {
    this.getTotal();
  },
  methods: {
    getOddsType(n) {
      var result = "";
      switch(n) {
        case 1:
          result = "(MY)";
          break;
        case 2:
          result = "(HK)";
          break;
        case 3:
          result = "(ID)";
          break;
        case 4:
          result = "(DEC)";
          break;
      }
      return result;
    },
    clearTotal() {
      this.subTotalTurnover = 0
      this.grandTotalTurnover = 0
      this.subTotalValidTurnover = 0
      this.grandTotalValidTurnover = 0
      this.subTotalWinLose = 0
      this.grandTotalWinLose = 0
      this.subTotalPayout = 0
      this.grandTotalPayout = 0
    },
    getTotal: function() {
      this.clearTotal();
      var tbl = this.tbl;
      if(tbl.length > 0) {
        tbl.forEach(value => {
          this.subTotalTurnover = parseFloat(this.subTotalTurnover) + parseFloat(value["turnover"]);
          this.subTotalValidTurnover = parseFloat(this.subTotalValidTurnover) + parseFloat(value["valid_turnover"]);
          this.subTotalWinLose = parseFloat(this.subTotalWinLose) + parseFloat(value["winlose"]);
          this.subTotalPayout = parseFloat(this.subTotalPayout) + parseFloat(value["payout"]);

        });

        var totalTbl = this.totalTbl;
        if(totalTbl.length > 0) {
          this.grandTotalTurnover = totalTbl[0]["turnover"];
          this.grandTotalValidTurnover = totalTbl[0]["valid_turnover"];
          this.grandTotalWinLose = totalTbl[0]["winlose"];
          this.grandTotalPayout = totalTbl[0]["payout"];
        }
      }
    }
  }
};
</script>
